module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirmation-dialog"
  }, [_c('v-modal', {
    attrs: {
      "show": _vm.show,
      "headerVisible": false,
      "size": 'm'
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('p', {
          staticStyle: {
            "height": "40px"
          }
        })]
      },
      proxy: true
    }, {
      key: "body",
      fn: function() {
        return [_c('div', {
          staticClass: "notifit_confirm_message"
        }, [_c('div', {
          staticClass: "general-nofi-modal-title"
        }, [_vm._v("\n                    " + _vm._s(_vm.message) + "\n                ")]), _vm._v(" "), _c('div', {
          staticClass: "general-nofi-modal-msg"
        }, [_vm._v("\n                    " + _vm._s(_vm.additionalMessage) + "\n                ")]), _vm._v(" "), (_vm.note) ? _c('div', {
          staticClass: "general-nofi-modal-msg margin-top-10"
        }, [_vm._v("\n                    " + _vm._s(_vm.note) + "\n                ")]) : _vm._e()])]
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function() {
        return [_c('p', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn btn-success btn-confirmation",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.yesClicked.apply(null, arguments)
            }
          }
        }, [_vm._v("YES")]), _vm._v(" "), _c('button', {
          staticClass: "btn btn-primary btn-confirmation",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancelClicked.apply(null, arguments)
            }
          }
        }, [_vm._v("NO")])])]
      },
      proxy: true
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3a739620!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/v-components/confirmation-dialog.vue
// module id = 178
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 17 18 19 20 21 24 25 26 27 28 34 35